import { render } from "./home.vue?vue&type=template&id=f8fa1952&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=f8fa1952&lang=scss&scoped=true"

import exportComponent from "D:\\git_codes\\wokespac\\isw-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8fa1952"]])

export default __exports__